// Chrome 53 compatibility polyfills
// Ensure all polyfills are loaded before any other code runs
// This file must be loaded synchronously before any other scripts

(function() {
  'use strict';

  // Debug logging for polyfill loading
  if (typeof console !== 'undefined' && console.log) {
    console.log('Chrome 53 polyfills loading...');
  }

  // Ensure polyfills are loaded immediately and synchronously
  // This is critical for Chrome 53 compatibility
if (typeof Object.assign !== 'function') {
  Object.assign = function(target) {
    if (target == null) {
      throw new TypeError('Cannot convert undefined or null to object');
    }

    var to = Object(target);

    for (var index = 1; index < arguments.length; index++) {
      var nextSource = arguments[index];

      if (nextSource != null) {
        for (var nextKey in nextSource) {
          if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
    return to;
  };
}

// Array.includes polyfill
if (!Array.prototype.includes) {
  Array.prototype.includes = function(searchElement, fromIndex) {
    if (this == null) {
      throw new TypeError('"this" is null or not defined');
    }

    var o = Object(this);
    var len = o.length >>> 0;

    if (len === 0) {
      return false;
    }

    var n = fromIndex | 0;
    var k = Math.max(n >= 0 ? n : len + n, 0);

    while (k < len) {
      if (o[k] === searchElement) {
        return true;
      }
      k++;
    }
    return false;
  };
}

// Array.find polyfill
if (!Array.prototype.find) {
  Array.prototype.find = function(predicate) {
    if (this == null) {
      throw new TypeError('Array.prototype.find called on null or undefined');
    }
    if (typeof predicate !== 'function') {
      throw new TypeError('predicate must be a function');
    }
    var list = Object(this);
    var length = parseInt(list.length) || 0;
    var thisArg = arguments[1];
    for (var i = 0; i < length; i++) {
      var element = list[i];
      if (predicate.call(thisArg, element, i, list)) {
        return element;
      }
    }
    return undefined;
  };
}

// Array.findIndex polyfill
if (!Array.prototype.findIndex) {
  Array.prototype.findIndex = function(predicate) {
    if (this == null) {
      throw new TypeError('Array.prototype.findIndex called on null or undefined');
    }
    if (typeof predicate !== 'function') {
      throw new TypeError('predicate must be a function');
    }
    var list = Object(this);
    var length = parseInt(list.length) || 0;
    var thisArg = arguments[1];
    for (var i = 0; i < length; i++) {
      var element = list[i];
      if (predicate.call(thisArg, element, i, list)) {
        return i;
      }
    }
    return -1;
  };
}

// Array.from polyfill
if (!Array.from) {
  Array.from = (function() {
    var toStr = Object.prototype.toString;
    var isCallable = function(fn) {
      return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
    };
    var toInteger = function(value) {
      var number = Number(value);
      if (isNaN(number)) { return 0; }
      if (number === 0 || !isFinite(number)) { return number; }
      return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
    };
    var maxSafeInteger = Math.pow(2, 53) - 1;
    var toLength = function(value) {
      var len = toInteger(value);
      return Math.min(Math.max(len, 0), maxSafeInteger);
    };

    return function from(arrayLike) {
      var C = this;
      var items = Object(arrayLike);
      if (arrayLike == null) {
        throw new TypeError('Array.from requires an array-like object - not null or undefined');
      }
      var mapFunction = arguments.length > 1 ? arguments[1] : void undefined;
      var T;
      if (typeof mapFunction !== 'undefined') {
        if (typeof mapFunction !== 'function') {
          throw new TypeError('Array.from: when provided, the second argument must be a function');
        }
        if (arguments.length > 2) {
          T = arguments[2];
        }
      }
      var len = toLength(items.length);
      var A = isCallable(C) ? Object(new C(len)) : new Array(len);
      var k = 0;
      var kValue;
      while (k < len) {
        kValue = items[k];
        if (mapFunction) {
          A[k] = typeof T === 'undefined' ? mapFunction(kValue, k) : mapFunction.call(T, kValue, k);
        } else {
          A[k] = kValue;
        }
        k += 1;
      }
      A.length = len;
      return A;
    };
  }());
}

// String.includes polyfill
if (!String.prototype.includes) {
  String.prototype.includes = function(search, start) {
    if (typeof start !== 'number') {
      start = 0;
    }

    if (start + search.length > this.length) {
      return false;
    } else {
      return this.indexOf(search, start) !== -1;
    }
  };
}

// String.startsWith polyfill
if (!String.prototype.startsWith) {
  String.prototype.startsWith = function(searchString, position) {
    position = position || 0;
    return this.substr(position, searchString.length) === searchString;
  };
}

// String.endsWith polyfill
if (!String.prototype.endsWith) {
  String.prototype.endsWith = function(searchString, length) {
    if (length === undefined || length > this.length) {
      length = this.length;
    }
    return this.substring(length - searchString.length, length) === searchString;
  };
}

// String.padStart polyfill
if (!String.prototype.padStart) {
  String.prototype.padStart = function padStart(targetLength, padString) {
    targetLength = targetLength >> 0;
    padString = String(typeof padString !== 'undefined' ? padString : ' ');
    if (this.length > targetLength) {
      return String(this);
    } else {
      targetLength = targetLength - this.length;
      if (targetLength > padString.length) {
        padString += padString.repeat(targetLength / padString.length);
      }
      return padString.slice(0, targetLength) + String(this);
    }
  };
}

// Fetch polyfill for Chrome 53
if (typeof fetch === 'undefined' || !window.fetch || typeof window.fetch !== 'function') {
  // Simple fetch polyfill using XMLHttpRequest
  window.fetch = function(url, options) {
    return new Promise(function(resolve, reject) {
      var xhr = new XMLHttpRequest();

      xhr.onload = function() {
        var response = {
          ok: xhr.status >= 200 && xhr.status < 300,
          status: xhr.status,
          statusText: xhr.statusText,
          headers: xhr.getAllResponseHeaders(),
          text: function() {
            return Promise.resolve(xhr.responseText);
          },
          json: function() {
            try {
              return Promise.resolve(JSON.parse(xhr.responseText));
            } catch (error) {
              return Promise.reject(new Error('Invalid JSON response: ' + error.message));
            }
          },
          clone: function() {
            return this;
          }
        };
        resolve(response);
      };

      xhr.onerror = function() {
        reject(new Error('Network request failed'));
      };

      xhr.open(options && options.method ? options.method : 'GET', url);

      if (options && options.headers) {
        for (var header in options.headers) {
          xhr.setRequestHeader(header, options.headers[header]);
        }
      }

      xhr.send(options && options.body ? options.body : null);
    });
  };
}

// Promise.finally polyfill
if (!Promise.prototype.finally) {
  Promise.prototype.finally = function(callback) {
    var P = this.constructor;
    return this.then(
      function(value) { return P.resolve(callback()).then(function() { return value; }); },
      function(reason) { return P.resolve(callback()).then(function() { throw reason; }); }
    );
  };
}

// Object.entries polyfill
if (!Object.entries) {
  Object.entries = function(obj) {
    var ownProps = Object.keys(obj),
        i = ownProps.length,
        resArray = new Array(i);
    while (i--)
      resArray[i] = [ownProps[i], obj[ownProps[i]]];

    return resArray;
  };
}

// Object.values polyfill
if (!Object.values) {
  Object.values = function(obj) {
    var vals = [];
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        vals.push(obj[key]);
      }
    }
    return vals;
  };
}

// URL polyfill for older browsers
if (typeof URL === 'undefined' || !window.URL) {
  window.URL = function(url, base) {
    if (base) {
      url = base + '/' + url;
    }

    var anchor = document.createElement('a');
    anchor.href = url;

    return {
      href: anchor.href,
      origin: anchor.protocol + '//' + anchor.hostname + (anchor.port ? ':' + anchor.port : ''),
      protocol: anchor.protocol,
      host: anchor.host,
      hostname: anchor.hostname,
      port: anchor.port,
      pathname: anchor.pathname,
      search: anchor.search,
      hash: anchor.hash,
      searchParams: new URLSearchParams(anchor.search)
    };
  };
}

// URLSearchParams polyfill
if (typeof URLSearchParams === 'undefined' || !window.URLSearchParams) {
  window.URLSearchParams = function(init) {
    this.params = {};

    if (init) {
      if (typeof init === 'string') {
        if (init.charAt(0) === '?') {
          init = init.slice(1);
        }
        var pairs = init.split('&');
        for (var i = 0; i < pairs.length; i++) {
          var pair = pairs[i].split('=');
          this.append(decodeURIComponent(pair[0]), decodeURIComponent(pair[1] || ''));
        }
      }
    }
  };

  URLSearchParams.prototype.append = function(name, value) {
    if (!this.params[name]) {
      this.params[name] = [];
    }
    this.params[name].push(value);
  };

  URLSearchParams.prototype.get = function(name) {
    return this.params[name] ? this.params[name][0] : null;
  };

  URLSearchParams.prototype.getAll = function(name) {
    return this.params[name] || [];
  };

  URLSearchParams.prototype.has = function(name) {
    return name in this.params;
  };

  URLSearchParams.prototype.set = function(name, value) {
    this.params[name] = [value];
  };

  URLSearchParams.prototype.delete = function(name) {
    delete this.params[name];
  };

  URLSearchParams.prototype.toString = function() {
    var pairs = [];
    for (var name in this.params) {
      for (var i = 0; i < this.params[name].length; i++) {
        pairs.push(encodeURIComponent(name) + '=' + encodeURIComponent(this.params[name][i]));
      }
    }
    return pairs.join('&');
  };
}

  // Debug logging for polyfill completion
  if (typeof console !== 'undefined' && console.log) {
    console.log('Chrome 53 polyfills loaded successfully');
  }

  // Ensure polyfills are available globally
  if (typeof window !== 'undefined') {
    window.__CHROME_53_POLYFILLS_LOADED__ = true;
  }

})();
